import { render, staticRenderFns } from "./BaseUploadButton.vue?vue&type=template&id=5482b504"
import script from "./BaseUploadButton.vue?vue&type=script&lang=ts"
export * from "./BaseUploadButton.vue?vue&type=script&lang=ts"
import style0 from "./BaseUploadButton.vue?vue&type=style&index=0&id=5482b504&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports